import React, { useEffect, useRef } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import './ReportsPopover.css';

/**
 * Reports anchored popover — frame only. Body is supplied by callers via
 * `children`; footer via `footer` (falls back to a Cancel/Continue pair).
 * Anchored above the chat input bar. Closes on Escape.
 */
const ReportsPopover = ({ open, onClose, title = 'Create report', children, footer }) => {
  const popoverRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="reports-popover" ref={popoverRef} role="dialog" aria-label={title}>
      <div className="reports-popover-head">
        <span className="reports-popover-title">{title}</span>
        <button
          type="button"
          className="reports-popover-close"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseIcon fontSize="small" />
        </button>
      </div>
      <div className="reports-popover-body">{children}</div>
      <div className="reports-popover-foot">
        {footer || (
          <>
            <button type="button" className="reports-btn" onClick={onClose}>
              Cancel
            </button>
            <button type="button" className="reports-btn reports-btn--primary" disabled>
              Continue
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ReportsPopover;
